<h2 mat-dialog-title *ngIf="editCrop.id === undefined">
  <i class="fas fa-plus me-2"></i>Create Crop
</h2>
<h2 mat-dialog-title *ngIf="editCrop.id !== undefined">
  <i class="fas fa-pen me-2"></i>Edit Crop for {{ editCrop.name }}
</h2>
<mat-dialog-content class="mat-typography">
  <form #CropForm="ngForm" id="CropForm" name="CropForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="name"
              name="name"
              [(ngModel)]="editCrop.name"
              placeholder="Name"
              required
              #name="ngModel"
            />
          </mat-form-field>
         
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="seasonStartMonth"
              name="seasonStartMonth"
              [(ngModel)]="editCrop.seasonStartMonth"
              placeholder="Season Start Month"
              #description="ngModel"
            />
          </mat-form-field>
         
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="seasonStartDay"
              name="seasonStartDay"
              [(ngModel)]="editCrop.seasonStartDay"
              placeholder="Season Start Day"
              #description="ngModel"
            />
          </mat-form-field>
         
        </div>
      </div>
    </div>
    <div class="row mb-3" *ngIf="editCrop.id === undefined">
      <div class="col-lg-2 col-12">
        <mat-checkbox
          name="isActive"
          id="isActive"
          [(ngModel)]="editCrop.isActive"
          color="primary"
        >
          Active
        </mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="py-0">
  <div class="custom-dialog-actions">
    <div class="btn-group">
      <button
        *ngIf="!submitting"
        type="submit"
        form="CropForm"
        color="primary"
        [disabled]="CropForm.invalid"
        (click)="onSubmit()"
        class="custom-button save-button"
      >
         <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="custom-button cancel-button" (click)="cancelClicked(CropForm, false)">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button></div>
   
  </div>
</mat-dialog-actions>
